export const ADDRESS_FIELD_KEYS = [
    'first_name',
    'last_name',
    'line1',
    'line2',
    'line3',
    'country',
    'city',
    'province',
    'postal_code',
    'phone',
    'identification_number',
];
// Being using in validationSchemas
export const DEFAULT_PHONE_REGEX = /^(\+)?(\d*)$/;
// Canadian postal code format: Letter Digit Letter [space] Digit Letter Digit (e.g. A1A 1A1)
export const CANADIAN_POSTAL_CODE_REGEX = /^[A-Z]\d[A-Z][ ]\d[A-Z]\d$/;
// Max length is determined by Arvato / shipping requirements. Should not be changed unless Bis Sys requirements have changed.
export const CRITICAL_MAX_LENGTH = 30;
export const DEFAULT_FIRST_NAME_FIELD = {
    type: 'first_name',
    label: 'First Name',
    required: true,
    maxLength: 20,
    pattern: /[a-zA-Z]/,
    autoCompleteField: 'given-name',
};
export const DEFAULT_LEGAL_FIRST_NAME_FIELD = {
    type: 'first_name',
    label: 'Legal First Name',
    required: true,
    maxLength: 20,
    pattern: /[a-zA-Z]/,
    autoCompleteField: 'given-name',
};
export const DEFAULT_LAST_NAME_FIELD = {
    type: 'last_name',
    label: 'Last Name',
    required: true,
    maxLength: 20,
    pattern: /[a-zA-Z]/,
    autoCompleteField: 'family-name',
};
export const DEFAULT_LEGAL_LAST_NAME_FIELD = {
    type: 'last_name',
    label: 'Legal Last Name',
    required: true,
    maxLength: 20,
    pattern: /[a-zA-Z]/,
    autoCompleteField: 'family-name',
};
export const DEFAULT_LINE_1_FIELD = {
    type: 'line1',
    label: 'Address',
    required: true,
    maxLength: CRITICAL_MAX_LENGTH,
    autoCompleteField: 'address-line1',
};
export const DEFAULT_LINE_2_FIELD = {
    type: 'line2',
    label: 'Apt., suite, etc. (Optional)',
    required: false,
    maxLength: CRITICAL_MAX_LENGTH,
    autoCompleteField: 'address-line2',
};
export const DEFAULT_LINE_3_FIELD = {
    type: 'line3',
    label: '',
    required: false,
    maxLength: 12,
    autoCompleteField: 'address-line3',
};
export const DEFAULT_COUNTRY_FIELD = {
    type: 'country',
    label: 'Country',
    required: true,
    autoCompleteField: 'country-name',
    maxLength: 3,
};
export const DEFAULT_CITY_FIELD = {
    type: 'city',
    label: 'City',
    required: true,
    maxLength: CRITICAL_MAX_LENGTH,
    autoCompleteField: 'address-level2',
};
export const DEFAULT_STATE_FIELD = {
    type: 'province',
    label: 'State',
    required: true,
    maxLength: CRITICAL_MAX_LENGTH,
    autoCompleteField: 'address-level1',
};
export const DEFAULT_PROVINCE_FIELD = {
    ...DEFAULT_STATE_FIELD,
    label: 'Province',
};
export const DEFAULT_STATE_PROVINCE_REGION_FIELD = {
    ...DEFAULT_STATE_FIELD,
    label: 'State/Province/Region',
    required: false,
};
export const DEFAULT_ZIP_CODE_FIELD = {
    type: 'postal_code',
    label: 'Zip Code',
    required: true,
    minLength: 3,
    maxLength: 10,
    autoCompleteField: 'postal-code',
};
export const DEFAULT_POSTAL_CODE_FIELD = {
    ...DEFAULT_ZIP_CODE_FIELD,
    label: 'Postal Code',
};
export const DEFAULT_PHONE_FIELD = {
    type: 'phone',
    label: 'Phone Number',
    required: true,
    minLength: 8,
    maxLength: CRITICAL_MAX_LENGTH,
    pattern: DEFAULT_PHONE_REGEX,
    autoCompleteField: 'tel',
    example: '9876543210',
};
export const DEFAULT_INTL_PHONE_FIELD = {
    ...DEFAULT_PHONE_FIELD,
    pattern: DEFAULT_PHONE_REGEX,
    example: '+496912345678',
};
